const product_variable = {}

product_variable.productCategory = [
    {
        'name': 'Disinfectant', 'id': 0, 'isOpen': false, 'children': [
            { "id": 0, 'name': 'TCCA' }, { "id": 1, 'name': 'SDIC' }, { "id": 2, 'name': 'Calcium Hypochlorite' }, { "id": 3, 'name': 'Cyanuric Acid' }
        ]
    },
    {
        'name': 'Flocculent', 'id': 1, 'isOpen': false, 'children': [
            { "id": 0, 'name': 'Copper Sulphate' }, { "id": 1, 'name': 'PAC' }, { "id": 2, 'name': 'PAM' }, { "id": 3, 'name': 'Aluminium Sulphate' }
        ]
    },
    {
        'name': 'Antisludging Agent', 'id': 2, 'isOpen': false, 'children': [
            { "id": 0, 'name': 'potash alum' }, { "id": 1, 'name': 'zeolite' }, { "id": 2, 'name': 'Cryolite' }, { "id": 3, 'name': 'ATMP' }, { "id": 4, 'name': 'HEDP' }
        ]
    }
];

product_variable.productList = [
    [
        [{
            'icon': require('../assets/images/products/tcca/tcca01-small.jpg'),
            'id': 'swimming-pool-disinfectant-90-percent-trichloroisocyanuric-acid-granule-TCCA-granular',
            'name': 'Swimming Pool Disinfectant 90% Trichloroisocyanuric Acid granule TCCA granular',
            'category': 0, 'subCategory': 0,
            'tag': 'TCCA, Chlorine,Trichloroisocyanuric Acid',
            'description': "    Trichloroisocyanuric Acid, shortly name TCCA, it's a strong oxidant and chlorinating agent and most important bleaches," +
                "chlorinating agent and disinfectants Advantage with high effective chlorine content, stable storage and transportation its high " +
                "bactericidal and bleaching power. It is a new generation of broad-spectrum, high-efficiency, low-toxicity fungicide, " +
                "bleach and anti-shrink agent with excellent bactericidal performance.\n" +
                "    Trichloroisocyanuric acid contains up to 90% active chlorine. It is mainly used for disinfection and sterilization of " +
                "drinking water, industrial recycled water, swimming pools, restaurants, hotels, public places, families, hospitals, " +
                "poultry eggs and prevention and control of fish lesions. TCCA plays a strong oxidation role by releasing hypochlorous " +
                "acid (HClO), which can quickly kill bacteria, viruses, algae and fungi, especially for pathogens in swimming pool water " +
                "and drinking water.\n" +
                "    Storage requirements: Store in a cool, dry, ventilated place, avoid contact with ammonia substances (such as liquid ammonia, urea), " +
                "oxidants and inflammables, to prevent explosion or combustion.",
            'images': [
                require('../assets/images/products/tcca/tcca0101.jpg'),
                require('../assets/images/products/tcca/tcca0102.jpg'),
            ]
        },
        {
            'icon': require('../assets/images/products/tcca/tcca02-small.jpg'),
            'id': '90-percent-chlorine-disinfection-trichloroisocyanuric-acid-TCCA-Powder',
            'name': '90% Chlorine Disinfection Trichloroisocyanuric Acid TCCA Powder',
            'category': 0, 'subCategory': 0,
            'tag': 'TCCA, Chlorine,Trichloroisocyanuric Acid',
            'description': "    Trichloroisocyanuric Acid, shortly name TCCA, it's a strong oxidant and chlorinating agent and most important bleaches," +
                "chlorinating agent and disinfectants Advantage with high effective chlorine content, stable storage and transportation its high " +
                "bactericidal and bleaching power. It is a new generation of broad-spectrum, high-efficiency, low-toxicity fungicide, " +
                "bleach and anti-shrink agent with excellent bactericidal performance.\n" +
                "    Trichloroisocyanuric acid contains up to 90% active chlorine. It is mainly used for disinfection and sterilization of " +
                "drinking water, industrial recycled water, swimming pools, restaurants, hotels, public places, families, hospitals, " +
                "poultry eggs and prevention and control of fish lesions. TCCA plays a strong oxidation role by releasing hypochlorous " +
                "acid (HClO), which can quickly kill bacteria, viruses, algae and fungi, especially for pathogens in swimming pool water " +
                "and drinking water.\n" +
                "    Storage requirements: Store in a cool, dry, ventilated place, avoid contact with ammonia substances (such as liquid ammonia, urea), " +
                "oxidants and inflammables, to prevent explosion or combustion.",
            'images': [
                require('../assets/images/products/tcca/tcca0101.jpg'),
                require('../assets/images/products/tcca/tcca0102.jpg'),
            ]
        },
        {
            'icon': require('../assets/images/products/tcca/tcca03-small.jpg'),
            'id': 'TCCA-90-percent-200g-tablet-trichloroisocyanuric-acid-effervescent-disinfectant-tablet',
            'name': 'TCCA 90% 200g Tablet Trichloroisocyanuric Acid Effervescent Disinfectant Tablet',
            'category': 0, 'subCategory': 0,
            'tag': 'TCCA, Chlorine,Trichloroisocyanuric Acid',
            'description': "    Trichloroisocyanuric Acid, shortly name TCCA, it's a strong oxidant and chlorinating agent and most important bleaches," +
                "chlorinating agent and disinfectants Advantage with high effective chlorine content, stable storage and transportation its high " +
                "bactericidal and bleaching power. It is a new generation of broad-spectrum, high-efficiency, low-toxicity fungicide, " +
                "bleach and anti-shrink agent with excellent bactericidal performance.\n" +
                "    Trichloroisocyanuric acid contains up to 90% active chlorine. It is mainly used for disinfection and sterilization of " +
                "drinking water, industrial recycled water, swimming pools, restaurants, hotels, public places, families, hospitals, " +
                "poultry eggs and prevention and control of fish lesions. TCCA plays a strong oxidation role by releasing hypochlorous " +
                "acid (HClO), which can quickly kill bacteria, viruses, algae and fungi, especially for pathogens in swimming pool water " +
                "and drinking water.\n" +
                "    Storage requirements: Store in a cool, dry, ventilated place, avoid contact with ammonia substances (such as liquid ammonia, urea), " +
                "oxidants and inflammables, to prevent explosion or combustion.",
            'images': [
                require('../assets/images/products/tcca/tcca0301.jpg'),
                require('../assets/images/products/tcca/tcca0302.jpg'),
            ]
        },
        {
            'icon': require('../assets/images/products/tcca/tcca04-small.jpg'),
            'id': 'multifunctional-disinfectant-3-inches-tablet-trichloroisocyanuric-acid-TCCA-swimming-pool-chlorinating-tablets',
            'name': 'Multifunctional disinfectant 3" tablet Trichloroisocyanuric Acid TCCA Swimming Pool Chlorinating Tablets',
            'category': 0, 'subCategory': 0,
            'tag': 'TCCA, Chlorine,Trichloroisocyanuric Acid',
            'description': "    Trichloroisocyanuric Acid, shortly name TCCA, it's a strong oxidant and chlorinating agent and most important bleaches," +
                "chlorinating agent and disinfectants Advantage with high effective chlorine content, stable storage and transportation its high " +
                "bactericidal and bleaching power. It is a new generation of broad-spectrum, high-efficiency, low-toxicity fungicide, " +
                "bleach and anti-shrink agent with excellent bactericidal performance.\n" +
                "    Trichloroisocyanuric acid contains up to 90% active chlorine. It is mainly used for disinfection and sterilization of " +
                "drinking water, industrial recycled water, swimming pools, restaurants, hotels, public places, families, hospitals, " +
                "poultry eggs and prevention and control of fish lesions. TCCA plays a strong oxidation role by releasing hypochlorous " +
                "acid (HClO), which can quickly kill bacteria, viruses, algae and fungi, especially for pathogens in swimming pool water " +
                "and drinking water.\n" +
                "    Storage requirements: Store in a cool, dry, ventilated place, avoid contact with ammonia substances (such as liquid ammonia, urea), " +
                "oxidants and inflammables, to prevent explosion or combustion.",
            'images': [
                require('../assets/images/products/tcca/tcca0401.jpg'),
                require('../assets/images/products/tcca/tcca0402.jpg'),
                require('../assets/images/products/tcca/tcca0403.jpg'),
            ]
        },],
        [{
            'icon': require('../assets/images/products/sdic/sdic01-small.jpg'),
            'id': 'chlorine-effervescent-SDIC-powder-dihydrate-sodium-dichloroisocyanurate',
            'name': 'Chlorine Effervescent SDIC Powder Dihydrate Sodium Dichloroisocyanurate',
            'category': 0, 'subCategory': 1,
            'tag': 'TAG123',
            'description': "    Sodium dichloroisocyanurate (SDIC) is an efficient chlorine-containing oxidizing disinfectant, " +
                "widely used in water treatment, medical health, industrial cleaning and other fields.\n" +
                "    The effective chlorine content of the product can reach more than 56%, 60%, and the chlorine content is " +
                "relatively high. In contact with water, hypochlorous acid (HClO) and cyanuric acid are released, which play a bactericidal role " +
                "and have low residual toxicity. It will not have any effect on human body, so it is safe touse.\n" +
                "    It is mainly used for disinfection of drinking water, industrial circulating water, swimming pools, public places, " +
                "home sand hospitals.\n" +
                "    Storage requirement: Keep in a cool, dry and ventilated place, avoid high temperature and humid environment. " +
                "Recommended storage temperature 0-6°C.",
            'images': [
                require('../assets/images/products/sdic/sdic0201.jpg'),
                require('../assets/images/products/sdic/sdic0202.jpg')
            ]
        },
        {
            'icon': require('../assets/images/products/sdic/sdic02-small.jpg'),
            'id': 'dichloro-sodium0dichloroisocyanurate-SDIC-56-percent-granular-nadcc-dihydrate-granule',
            'name': 'Dichloro Sodium Dichloroisocyanurate SDIC 56% Granular Nadcc Dihydrate granule',
            'category': 0, 'subCategory': 1,
            'tag': 'TAG123',
            'description': "    Sodium dichloroisocyanurate (SDIC) is an efficient chlorine-containing oxidizing disinfectant, " +
                "widely used in water treatment, medical health, industrial cleaning and other fields.\n" +
                "    The effective chlorine content of the product can reach more than 56%, 60%, and the chlorine content is " +
                "relatively high. In contact with water, hypochlorous acid (HClO) and cyanuric acid are released, which play a bactericidal role " +
                "and have low residual toxicity. It will not have any effect on human body, so it is safe touse.\n" +
                "    It is mainly used for disinfection of drinking water, industrial circulating water, swimming pools, public places, " +
                "home sand hospitals.\n" +
                "    Storage requirement: Keep in a cool, dry and ventilated place, avoid high temperature and humid environment. " +
                "Recommended storage temperature 0-6°C.",
            'images': [
                require('../assets/images/products/sdic/sdic0201.jpg'),
                require('../assets/images/products/sdic/sdic0202.jpg')
            ]
        },
        {
            'icon': require('../assets/images/products/sdic/sdic03-small.jpg'),
            'id': 'pool-disinfectant-sodium-dichloroisocyanurate-SDIC-56-percent-60-percent-20g-tablet',
            'name': 'Pool Disinfectant Sodium Dichloroisocyanurate SDIC 56% 60% 20g Tablet',
            'category': 0, 'subCategory': 1,
            'tag': 'TAG123',
            'description': "    Sodium dichloroisocyanurate (SDIC) is an efficient chlorine-containing oxidizing disinfectant, " +
                "widely used in water treatment, medical health, industrial cleaning and other fields.\n" +
                "    The effective chlorine content of the product can reach more than 56%, 60%, and the chlorine content is " +
                "relatively high. In contact with water, hypochlorous acid (HClO) and cyanuric acid are released, which play a bactericidal role " +
                "and have low residual toxicity. It will not have any effect on human body, so it is safe touse.\n" +
                "    It is mainly used for disinfection of drinking water, industrial circulating water, swimming pools, public places, " +
                "home sand hospitals.\n" +
                "    Storage requirement: Keep in a cool, dry and ventilated place, avoid high temperature and humid environment. " +
                "Recommended storage temperature 0-6°C.",
            'images': [
                require('../assets/images/products/sdic/sdic0301.jpg'),
                require('../assets/images/products/sdic/sdic0302.jpg')
            ]
        }],
        [{
            'icon': require('../assets/images/products/calcium/calcium01-small.jpg'),
            'id': 'calcium-hypochlorite-65-percent-70-percent-granular-disinfectant-granule-by-sodium-process-bleaching-powder',
            'name': 'Calcium Hypochlorite 65% 70% Granular Disinfectant Granule by Sodium Process Bleaching Powder',
            'category': 0, 'subCategory': 2,
            'tag': 'TAG123',
            'description': "    Industrial Grade Calcium Hypochlorite 65%-70% By Sodium Process is a white solid, also known as Bleaching " +
                "Powder or the chemical formula Ca(ClO)₂, is commonly used in the bleaching process of chemical production and plays an important role " +
                "in industrial production because of its rapid onset and prominent bleaching effect.\n" +
                "    It strongly smells of chlorine, owing to its slow decomposition in moist air.This compound is relatively stable as a solid " +
                "and solution and has greater available chlorine than sodium hypochlorite.Calcium hypochlorite is a versatile chemical that finds " +
                "its application in various industries.\n" +
                "    Where can use Calcium Hypochlorite:\n" +
                "    1. Urban sewage: It has strong alkalinity and can neutralize water quality and meet emission standards.\n" +
                "    2. Mining production: mostly used for gold mining\n" +
                "    3. Disinfectant: disinfection of aquaculture, silkworm, pond, barn, etc.\n" +
                "    4. Swimming pool disinfection: mostly used in Africa, South America.",
            'images': [
                require('../assets/images/products/calcium/calcium0101.jpg'),
                require('../assets/images/products/calcium/calcium0102.jpg')
            ]
        }],
        [{
            'icon': require('../assets/images/products/cyanuric/cyanuric01-small.jpg'),
            'id': 'swimming-pool-disinfectant-90-percent-cyanuric-acid-granule-granular',
            'name': 'Swimming Pool Disinfectant 90% Cyanuric Acid granule granular',
            'category': 0, 'subCategory': 3,
            'tag': 'TCCA 200g tablet',
            'description': "    Cyanuric acid, also known as isocyanuric acid and cyanuric acid," +
                " is the main raw material for the production of Trichloroisocyanuric Acid TCCA and Sodium Dichloroisocyanurate SDIC. " +
                "It is used in the synthesis of new disinfectants, water treatment agents, bleach, chlorination agents, brominating agents, " +
                "antioxidants, paints and coatings, selective herbicides and metal cyanide moderators, and can also be directly used as " +
                "chlorine stabilizers for swimming pools. Nylon, plastic, polyester flame retardant and cosmetic additives, special resin synthesis.",
            'images': [
                require('../assets/images/products/cyanuric/cyanuric0101.jpg'),
                require('../assets/images/products/cyanuric/cyanuric0102.jpg'),
            ]
        },
        {
            'icon': require('../assets/images/products/cyanuric/cyanuric02-small.jpg'),
            'id': '90-percent-chlorine-disinfection-cyanuric-acid-powder',
            'name': '90% Chlorine Disinfection Cyanuric Acid Powder',
            'category': 0, 'subCategory': 3,
            'tag': 'TAG123',
            'description': "    Cyanuric acid, also known as isocyanuric acid and cyanuric acid," +
                " is the main raw material for the production of Trichloroisocyanuric Acid TCCA and Sodium Dichloroisocyanurate SDIC. " +
                "It is used in the synthesis of new disinfectants, water treatment agents, bleach, chlorination agents, brominating agents, " +
                "antioxidants, paints and coatings, selective herbicides and metal cyanide moderators, and can also be directly used as " +
                "chlorine stabilizers for swimming pools. Nylon, plastic, polyester flame retardant and cosmetic additives, special resin synthesis.",
            'images': [
                require('../assets/images/products/cyanuric/cyanuric0101.jpg'),
                require('../assets/images/products/cyanuric/cyanuric0102.jpg'),
            ]
        },
        {
            'icon': require('../assets/images/products/cyanuric/cyanuric03-small.jpg'),
            'id': 'cyanuric-acid-90-percent-200g-tablet-effervescent-disinfectant-tablet',
            'name': 'Cyanuric Acid 90% 200g Tablet Effervescent Disinfectant Tablet',
            'category': 0, 'subCategory': 3,
            'tag': 'TAG123',
            'description': "    Cyanuric acid, also known as isocyanuric acid and cyanuric acid," +
                " is the main raw material for the production of Trichloroisocyanuric Acid TCCA and Sodium Dichloroisocyanurate SDIC. " +
                "It is used in the synthesis of new disinfectants, water treatment agents, bleach, chlorination agents, brominating agents, " +
                "antioxidants, paints and coatings, selective herbicides and metal cyanide moderators, and can also be directly used as " +
                "chlorine stabilizers for swimming pools. Nylon, plastic, polyester flame retardant and cosmetic additives, special resin synthesis.",
            'images': [
                require('../assets/images/products/cyanuric/cyanuric0301.jpg'),
                require('../assets/images/products/cyanuric/cyanuric0302.jpg'),
            ]
        }],
    ],
    [
        [],
        [{
            'icon': require('../assets/images/products/pac/pac01-small.jpg'),
            'id': 'PAC-flocculant-poly-aluminum-chloride-coagulant-aluminum-chlorohydrate',
            'name': 'PAC Flocculant Poly Aluminum Chloride Coagulant Aluminum Chlorohydrate',
            'category': 1, 'subCategory': 1,
            'tag': '1327-41-9 ',
            'description': "    Polyaluminum chloride (PAC), referred to as polyaluminum, is a water-soluble inorganic polymer between AlCl3 and Al(OH)3. " +
                "Polyaluminum chloride is divided into two kinds for drinking water and industrial water. The fundamental difference between polyaluminum " +
                "chloride and traditional inorganic coagulant is that the traditional inorganic coagulant is low molecular crystalline salt, while the " +
                "structure of polyaluminum chloride is composed of multi-carboxyl complex with variable morphology, fast flocculation and precipitation rate, " +
                "wide pH range, non-corrosive to pipeline equipment, and obvious water purification effect. It can effectively remove SS, COD, BOD and heavy " +
                "metal ions such as arsenic and mercury in water.\n" +
                "    The most widely used area of polyaluminum chloride is water treatment, especially the purification of drinking water, " +
                "sewage and industrial wastewater.It also can use as Coating Auxiliary Agents, Electronics Chemicals, Leather Auxiliary Agents, " +
                "Paper Chemicals, Petroleum Additives, Plastic Auxiliary Agents, Rubber Auxiliary Agents, Surfactants, Textile Auxiliary Agents.",
            'images': [
                require('../assets/images/products/pac/pac0101.jpg'),
                require('../assets/images/products/pac/pac0102.jpg'),
            ]
        }],
        [{
            'icon': require('../assets/images/products/pam/pam01-small.jpg'),
            'id': 'PAM-flocculant-polyacrylamide-powder-cationic-and-anionic-poly-acrylamide-chemical-auxiliary-agent',
            'name': 'PAM Flocculant Polyacrylamide powder Cationic and Anionic Poly Acrylamide Chemical Auxiliary Agent',
            'category': 1, 'subCategory': 2,
            'tag': 'Slude dewatering,drlling mud,paper,textile sizing agent',
            'description': "    Polyacrylamide (PAM) is a linear polymer with good thermal stability. It can be dissolved in water in any proportion, " +
                "and the aqueous solution is a uniform and transparent liquid. PAM has three types: Cationic PAM, Anionic PAM, and Nonionic PAM. " +
                "It is widely used in water treatment, paper making, mining, metallurgy, oil mining, medicine, agriculture and other industries. \n" +
                "    Operational performance:\n" +
                "    1, Flocculation: PAM can make suspended substances through electric neutralization, bridge adsorption, flocculation.\n" +
                "    2, Adhesion: through mechanical, physical, chemical action, play a bonding role.\n" +
                "    3, Resistance reduction: PAM can effectively reduce the friction resistance of the fluid, adding a trace of PAM in the water " +
                "can reduce the resistance of 50-80 %.\n" +
                "    4, Thickening: PAM has a thickening effect under neutral and acid conditions, when the PH value is above 10 PAM is easy to hydrolysis." +
                " The thickening will be more pronounced when the structure is semi- reticulated.",
            'images': [
                require('../assets/images/products/pam/pam0101.jpg'),
            ]
        }],
        [{
            'icon': require('../assets/images/products/aluminium/aluminium01-small.jpg'),
            'id': 'white-flakes-aluminium-sulfate-16-percent-17-percent-low-non-iron-sulfato-de-aluminio',
            'name': 'White flakes Aluminium sulfate 16% 17% low/non-iron Sulfato De Aluminio',
            'category': 1, 'subCategory': 3,
            'tag': '10043-01-3',
            'description': "    Aluminum sulfate is an inorganic compound. It is soluble in water and is mainly used as a" +
                " coagulating agent in the purification of drinking water and wastewater treatment plants, and also in paper manufacturing.\n" +
                "    1. Water treatment: used as a flocculant to remove fine impurities in water, so used as a coagulant for water supply and wastewater;\n" +
                "    2. Paper industry: used as a paper sizing agent to enhance the water resistance and impermeability of paper;\n" +
                "    3. Textile Industry: It is used for color fixing in Naphthol based dyes for cotton fabric.\n" +
                "    Other Uses: Leather tanning, lubricating compositions, fire retardants; decolorizing agent in petroleum, deodorizer; firming agent; dyeing mordant; " +
                "foaming agent in firefighting foams; fireproofing cloth; catalyst; pH control; waterproofing concrete; aluminum compounds, zeolites etc.\n" +
                "    Storage and transportation: Store in a cool, dry and clean warehouse, which should be moisture- proof.It can't be stored and transported" +
                " together with toxic or alkaline substances.",
            'images': [
                require('../assets/images/products/aluminium/aluminium0101.jpg'),
            ]
        }],

    ],
    [
        [],
        [],
        [],
        [],
        [],

    ],
]

product_variable.homeProductList = [
    {
        'icon': require('../assets/images/products/tcca/tcca01-small.jpg'),
        'id': 'swimming-pool-disinfectant-90-percent-trichloroisocyanuric-acid-granule-TCCA-granular',
        'name': 'Swimming Pool Disinfectant 90% Trichloroisocyanuric Acid granule TCCA granular',
        'category': 0, 'subCategory': 0,
        'tag': 'TCCA, Chlorine,Trichloroisocyanuric Acid',
        'description': "    Trichloroisocyanuric Acid, shortly name TCCA, it's a strong oxidant and chlorinating agent and most important bleaches," +
            "chlorinating agent and disinfectants Advantage with high effective chlorine content, stable storage and transportation its high " +
            "bactericidal and bleaching power. It is a new generation of broad-spectrum, high-efficiency, low-toxicity fungicide, " +
            "bleach and anti-shrink agent with excellent bactericidal performance.\n" +
            "    Trichloroisocyanuric acid contains up to 90% active chlorine. It is mainly used for disinfection and sterilization of " +
            "drinking water, industrial recycled water, swimming pools, restaurants, hotels, public places, families, hospitals, " +
            "poultry eggs and prevention and control of fish lesions. TCCA plays a strong oxidation role by releasing hypochlorous " +
            "acid (HClO), which can quickly kill bacteria, viruses, algae and fungi, especially for pathogens in swimming pool water " +
            "and drinking water.\n" +
            "    Storage requirements: Store in a cool, dry, ventilated place, avoid contact with ammonia substances (such as liquid ammonia, urea), " +
            "oxidants and inflammables, to prevent explosion or combustion.",
        'images': [
            require('../assets/images/products/tcca/tcca0101.jpg'),
            require('../assets/images/products/tcca/tcca0102.jpg')
        ]
    },
    {
        'icon': require('../assets/images/products/sdic/sdic01-small.jpg'),
        'id': 'chlorine-effervescent-SDIC-powder-dihydrate-sodium-dichloroisocyanurate',
        'name': 'Chlorine Effervescent SDIC Powder Dihydrate Sodium Dichloroisocyanurate',
        'category': 0, 'subCategory': 1,
        'tag': 'TAG123',
        'description': "    Sodium dichloroisocyanurate (SDIC) is an efficient chlorine-containing oxidizing disinfectant, " +
            "widely used in water treatment, medical health, industrial cleaning and other fields.\n" +
            "    The effective chlorine content of the product can reach more than 56%, 60%, and the chlorine content is " +
            "relatively high. In contact with water, hypochlorous acid (HClO) and cyanuric acid are released, which play a bactericidal role " +
            "and have low residual toxicity. It will not have any effect on human body, so it is safe touse.\n" +
            "    It is mainly used for disinfection of drinking water, industrial circulating water, swimming pools, public places, " +
            "home sand hospitals.\n" +
            "    Storage requirement: Keep in a cool, dry and ventilated place, avoid high temperature and humid environment. " +
            "Recommended storage temperature 0-6°C.",
        'images': [
            require('../assets/images/products/sdic/sdic0201.jpg'),
            require('../assets/images/products/sdic/sdic0202.jpg')
        ]
    },
    {
        'icon': require('../assets/images/products/calcium/calcium01-small.jpg'),
        'id': 'calcium-hypochlorite-65-percent-70-percent-granular-disinfectant-granule-by-sodium-process-bleaching-powder',
        'name': 'Calcium Hypochlorite 65% 70% Granular Disinfectant Granule by Sodium Process Bleaching Powder',
        'category': 0, 'subCategory': 2,
        'tag': 'TAG123',
        'description': "    Industrial Grade Calcium Hypochlorite 65%-70% By Sodium Process is a white solid, also known as Bleaching " +
            "Powder or the chemical formula Ca(ClO)₂, is commonly used in the bleaching process of chemical production and plays an important role " +
            "in industrial production because of its rapid onset and prominent bleaching effect.\n" +
            "    It strongly smells of chlorine, owing to its slow decomposition in moist air.This compound is relatively stable as a solid " +
            "and solution and has greater available chlorine than sodium hypochlorite.Calcium hypochlorite is a versatile chemical that finds " +
            "its application in various industries.\n" +
            "    Where can use Calcium Hypochlorite:\n" +
            "    1. Urban sewage: It has strong alkalinity and can neutralize water quality and meet emission standards.\n" +
            "    2. Mining production: mostly used for gold mining\n" +
            "    3. Disinfectant: disinfection of aquaculture, silkworm, pond, barn, etc.\n" +
            "    4. Swimming pool disinfection: mostly used in Africa, South America.",
        'images': [
            require('../assets/images/products/calcium/calcium0101.jpg'),
            require('../assets/images/products/calcium/calcium0102.jpg')
        ]
    },
    {
        'icon': require('../assets/images/products/cyanuric/cyanuric01-small.jpg'),
        'id': 'swimming-pool-disinfectant-90-percent-cyanuric-acid-granule-granular',
        'name': 'Swimming Pool Disinfectant 90% Cyanuric Acid granule granular',
        'category': 0, 'subCategory': 3,
        'tag': 'TCCA 200g tablet',
        'description': "    Cyanuric acid, also known as isocyanuric acid and cyanuric acid," +
            " is the main raw material for the production of Trichloroisocyanuric Acid TCCA and Sodium Dichloroisocyanurate SDIC. " +
            "It is used in the synthesis of new disinfectants, water treatment agents, bleach, chlorination agents, brominating agents, " +
            "antioxidants, paints and coatings, selective herbicides and metal cyanide moderators, and can also be directly used as " +
            "chlorine stabilizers for swimming pools. Nylon, plastic, polyester flame retardant and cosmetic additives, special resin synthesis.",
        'images': [
            require('../assets/images/products/cyanuric/cyanuric0101.jpg'),
            require('../assets/images/products/cyanuric/cyanuric0102.jpg'),
        ]
    },
    {
        'icon': require('../assets/images/products/pac/pac01-small.jpg'),
        'id': 'PAC-flocculant-poly-aluminum-chloride-coagulant-aluminum-chlorohydrate',
        'name': 'PAC Flocculant Poly Aluminum Chloride Coagulant Aluminum Chlorohydrate',
        'category': 1, 'subCategory': 1,
        'tag': '1327-41-9 ',
        'description': "    Polyaluminum chloride (PAC), referred to as polyaluminum, is a water-soluble inorganic polymer between AlCl3 and Al(OH)3. " +
            "Polyaluminum chloride is divided into two kinds for drinking water and industrial water. The fundamental difference between polyaluminum " +
            "chloride and traditional inorganic coagulant is that the traditional inorganic coagulant is low molecular crystalline salt, while the " +
            "structure of polyaluminum chloride is composed of multi-carboxyl complex with variable morphology, fast flocculation and precipitation rate, " +
            "wide pH range, non-corrosive to pipeline equipment, and obvious water purification effect. It can effectively remove SS, COD, BOD and heavy " +
            "metal ions such as arsenic and mercury in water.\n" +
            "    The most widely used area of polyaluminum chloride is water treatment, especially the purification of drinking water, " +
            "sewage and industrial wastewater.It also can use as Coating Auxiliary Agents, Electronics Chemicals, Leather Auxiliary Agents, " +
            "Paper Chemicals, Petroleum Additives, Plastic Auxiliary Agents, Rubber Auxiliary Agents, Surfactants, Textile Auxiliary Agents.",
        'images': [
            require('../assets/images/products/pac/pac0101.jpg'),
            require('../assets/images/products/pac/pac0102.jpg'),
        ]
    },
    {
        'icon': require('../assets/images/products/pam/pam01-small.jpg'),
        'id': 'PAM-flocculant-polyacrylamide-powder-cationic-and-anionic-poly-acrylamide-chemical-auxiliary-agent',
        'name': 'PAM Flocculant Polyacrylamide powder Cationic and Anionic Poly Acrylamide Chemical Auxiliary Agent',
        'category': 1, 'subCategory': 2,
        'tag': 'Slude dewatering,drlling mud,paper,textile sizing agent',
        'description': "    Polyacrylamide (PAM) is a linear polymer with good thermal stability. It can be dissolved in water in any proportion, " +
            "and the aqueous solution is a uniform and transparent liquid. PAM has three types: Cationic PAM, Anionic PAM, and Nonionic PAM. " +
            "It is widely used in water treatment, paper making, mining, metallurgy, oil mining, medicine, agriculture and other industries. \n" +
            "    Operational performance:\n" +
            "    1, Flocculation: PAM can make suspended substances through electric neutralization, bridge adsorption, flocculation.\n" +
            "    2, Adhesion: through mechanical, physical, chemical action, play a bonding role.\n" +
            "    3, Resistance reduction: PAM can effectively reduce the friction resistance of the fluid, adding a trace of PAM in the water " +
            "can reduce the resistance of 50-80 %.\n" +
            "    4, Thickening: PAM has a thickening effect under neutral and acid conditions, when the PH value is above 10 PAM is easy to hydrolysis." +
            " The thickening will be more pronounced when the structure is semi- reticulated.",
        'images': [
            require('../assets/images/products/pam/pam0101.jpg'),
        ]
    },
    {
        'icon': require('../assets/images/products/aluminium/aluminium01-small.jpg'),
        'id': 'white-flakes-aluminium-sulfate-16-percent-17-percent-low-non-iron-sulfato-de-aluminio',
        'name': 'White flakes Aluminium sulfate 16% 17% low/non-iron Sulfato De Aluminio',
        'category': 1, 'subCategory': 3,
        'tag': '10043-01-3',
        'description': "    Aluminum sulfate is an inorganic compound. It is soluble in water and is mainly used as a" +
            " coagulating agent in the purification of drinking water and wastewater treatment plants, and also in paper manufacturing.\n" +
            "    1. Water treatment: used as a flocculant to remove fine impurities in water, so used as a coagulant for water supply and wastewater;\n" +
            "    2. Paper industry: used as a paper sizing agent to enhance the water resistance and impermeability of paper;\n" +
            "    3. Textile Industry: It is used for color fixing in Naphthol based dyes for cotton fabric.\n" +
            "    Other Uses: Leather tanning, lubricating compositions, fire retardants; decolorizing agent in petroleum, deodorizer; firming agent; dyeing mordant; " +
            "foaming agent in firefighting foams; fireproofing cloth; catalyst; pH control; waterproofing concrete; aluminum compounds, zeolites etc.\n" +
            "    Storage and transportation: Store in a cool, dry and clean warehouse, which should be moisture- proof.It can't be stored and transported" +
            " together with toxic or alkaline substances.",
        'images': [
            require('../assets/images/products/aluminium/aluminium0101.jpg'),
        ]
    },
    {
        'icon': require('../assets/images/products/cyanuric/cyanuric03-small.jpg'),
        'id': 'cyanuric-acid-90-percent-200g-tablet-effervescent-disinfectant-tablet',
        'name': 'Cyanuric Acid 90% 200g Tablet Effervescent Disinfectant Tablet',
        'category': 0, 'subCategory': 3,
        'tag': 'TAG123',
        'description': "    Cyanuric acid, also known as isocyanuric acid and cyanuric acid," +
            " is the main raw material for the production of Trichloroisocyanuric Acid TCCA and Sodium Dichloroisocyanurate SDIC. " +
            "It is used in the synthesis of new disinfectants, water treatment agents, bleach, chlorination agents, brominating agents, " +
            "antioxidants, paints and coatings, selective herbicides and metal cyanide moderators, and can also be directly used as " +
            "chlorine stabilizers for swimming pools. Nylon, plastic, polyester flame retardant and cosmetic additives, special resin synthesis.",
        'images': [
            require('../assets/images/products/cyanuric/cyanuric0301.jpg'),
            require('../assets/images/products/cyanuric/cyanuric0302.jpg'),
        ]
    }
]

export default product_variable